import { useCallback, useState } from 'react';
import ClientStorage from 'ClientStorage';
import { type CurrentUser } from 'Users';
import { type DisplayMode } from '../BrowseCourses.types';

// The key the Angular HasToggleableDisplayMode mixin used, so the saved preference still applies
export const DISPLAY_MODE_STORAGE_KEY = 'toggleableCourseListLibrary';

function initialDisplayMode(currentUser: CurrentUser | null): DisplayMode {
    // High school Blue Ocean students have one course. This overrides any saved preference.
    if (currentUser?.signUpCode === 'BOSHIGH') return 'flat';

    // A legacy 'playlist' value, or no saved value, means topic mode
    return ClientStorage.getItem(DISPLAY_MODE_STORAGE_KEY) === 'flat' ? 'flat' : 'topic';
}

export function useDisplayMode(currentUser: CurrentUser | null) {
    const [displayMode, setDisplayModeState] = useState<DisplayMode>(() => initialDisplayMode(currentUser));

    const setDisplayMode = useCallback((mode: DisplayMode) => {
        setDisplayModeState(mode);
        ClientStorage.setItem(DISPLAY_MODE_STORAGE_KEY, mode);
    }, []);

    return [displayMode, setDisplayMode] as const;
}
